import { Routes } from '@angular/router';

export const LEGACY_ROUTES: Routes = [
  {
    path: 'createaccount',
    redirectTo: 'register',
    pathMatch: 'prefix',
  },
  {
    path: 'createaccount.aspx',
    redirectTo: 'register',
    pathMatch: 'prefix',
  },
  {
    path: 'login',
    redirectTo: '',
    pathMatch: 'prefix',
  },
  {
    path: 'login.aspx',
    redirectTo: '',
    pathMatch: 'prefix',
  },
  {
    path: 'updatenow',
    redirectTo: '',
    pathMatch: 'prefix',
  },
  {
    path: 'updatenow.aspx',
    redirectTo: '',
    pathMatch: 'prefix',
  },
  {
    path: 'forgotpassword',
    redirectTo: 'forgot-password',
    pathMatch: 'prefix',
  },
  {
    path: 'forgotpassword.aspx',
    redirectTo: 'forgot-password',
    pathMatch: 'prefix',
  },
  {
    path: 'resetpassword',
    redirectTo: 'set-password',
    pathMatch: 'prefix',
  },
  {
    path: 'resetpassword.aspx',
    redirectTo: 'set-password',
    pathMatch: 'prefix',
  },
  {
    path: 'reset-password',
    redirectTo: 'set-password',
    pathMatch: 'prefix',
  },
  {
    path: 'setpassword',
    redirectTo: 'set-password',
    pathMatch: 'prefix',
  },
  {
    path: 'setpassword.aspx',
    redirectTo: 'set-password',
    pathMatch: 'prefix',
  },
  {
    path: 'validateemail',
    redirectTo: 'change-email',
    pathMatch: 'prefix',
  },
  {
    path: 'cancelemailvalidation',
    redirectTo: 'change-email/cancel',
    pathMatch: 'prefix',
  },
];
